/** Bounded prefix match — `path` OR `path + '/'` — so `/catalog-v2/runs-x` can't light up Runs. */
export function isUnder(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(prefix + '/');
}
